// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"575":"b3ea5b5f","780":"2ab3c301"}[chunkId] + ".chunk.css");